var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMarsh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1547 919",
    width: 1547,
    height: 919,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MarshMcLennan_h_rgb_c-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #002c77 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M1504.63 198.42L1177.59 9.95C1154.56 -3.32 1116.87 -3.32 1093.83 9.95L191.61 529.88L690.88 147.23L452.66 9.95C429.62 -3.32 391.93 -3.32 368.9 9.95L41.86 198.42C18.83 211.69 -0.02 244.3 0 270.87L0 647.63C-0.02 674.25 18.83 706.86 41.86 720.13L368.9 908.6C391.93 921.87 429.62 921.87 452.66 908.6L1354.88 388.68L855.61 771.32L1093.83 908.6C1116.87 921.87 1154.56 921.87 1177.59 908.6L1504.63 720.13C1527.66 706.86 1546.51 674.25 1546.51 647.66L1546.51 270.89C1546.51 244.3 1527.66 211.69 1504.63 198.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarsh);
export default __webpack_public_path__ + "static/media/icon-marsh.c249741e2861e6ad48e5db62ffa86d12.svg";
export { ForwardRef as ReactComponent };